import { withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
    ref: "modalRef",
    role: "dialog",
    tabindex: "-1",
    "aria-modal": "true",
    "aria-label": "Modal window"
  }, _ctx.$attrs, {
    class: `v-modal ${_ctx.className}`,
    style: _ctx.styleClass,
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
  }), [
    _createElementVNode("div", {
      class: "v-modal-contain",
      style: _normalizeStyle({ maxWidth: `${_ctx.maxWidth}rem` })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(`v-modal-container ${_ctx.modalClass}`),
        style: _normalizeStyle(_ctx.styleClassContain),
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
        onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onscroll && _ctx.onscroll(...args)))
      }, [
        _renderSlot(_ctx.$slots, "default", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }),
        _renderSlot(_ctx.$slots, "close", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        })
      ], 38)
    ], 4)
  ], 16)), [
    [_vShow, _ctx.show]
  ])
}